document.addEventListener('DOMContentLoaded', initGlossary);
document.addEventListener('shopify:section:load', () => setTimeout(initGlossary, 200));

// Écoute l'ouverture des quick-views
document.addEventListener('click', (e) => {
  const quickViewTrigger = e.target.closest('[data-quick-view], .quick-view-trigger, [aria-label*="Quick"], [aria-label*="Aperçu"]');
  if (quickViewTrigger) {
    setTimeout(initGlossary, 500);
  }
});

// Observer pour détecter l'ajout de modales/quick-views dans le DOM
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1 && (
        node.classList?.contains('quick-view') ||
        node.classList?.contains('modal') ||
        node.querySelector?.('.quick-view, .modal, [role="dialog"]')
      )) {
        setTimeout(initGlossary, 300);
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });

function initGlossary() {
  if (!window.glossaryTerms) return;

  const terms = window.glossaryTerms;
  const contentArea = document.querySelector('main, body');
  if (!contentArea) return;

  const detectedTerms = [];
  const usedTerms = new Set();

  // Détecte une seule occurrence par terme dans l'ordre d'apparition
  const walker = document.createTreeWalker(contentArea, NodeFilter.SHOW_TEXT);
  let node;
  while (node = walker.nextNode()) {
    const parent = node.parentElement;
    if (!parent || ['SCRIPT','STYLE','NOSCRIPT','IFRAME'].includes(parent.tagName)) continue;

    // Exclut les éléments cachés ET les filtres/listes déroulantes
    const style = window.getComputedStyle(parent);
    if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0) continue;
    
    // Exclut les zones de filtres et listes déroulantes
    if (parent.closest('select, option, [role="listbox"], [role="option"], .facets, .filter, [data-filter], .dropdown, [aria-expanded]')) continue;

    Object.keys(terms).forEach(termKey => {
      const lowerKey = termKey.toLowerCase();
      if (usedTerms.has(lowerKey)) return;

      const regex = new RegExp(`\\b(${termKey})\\b`, 'i');
      if (regex.test(node.textContent)) {
        detectedTerms.push({ term: termKey, definition: terms[termKey] });
        usedTerms.add(lowerKey);
      }
    });
  }

  if (!detectedTerms.length) return;
  window.detectedTerms = detectedTerms;

  // Évite de créer plusieurs conteneurs
  let container = document.getElementById('glossary-container');
  if (container) return;

  let currentIndex = 0;
  const panelWidth = 300;
  const cornerWidth = 28;
  const panelColor = '#3d2817';
  let isOpen = false;

  // ===== Création panneau et coin =====
  container = document.createElement('div');
  container.id = 'glossary-container';
  container.style.cssText = `
    position: fixed;
    top: 10%;
    right: 0;
    transform: translateX(${panelWidth}px);
    z-index: 9999;
    transition: transform 0.4s cubic-bezier(0.25, 1.25, 0.5, 1);
    font-family: sans-serif;
    display: flex;
  `;

  const panel = document.createElement('div');
  panel.id = 'glossary-panel';
  panel.style.cssText = `
    background:${panelColor};
    color:#fff;
    padding:16px;
    border-radius:12px 0 0 12px;
    box-shadow:0 8px 24px rgba(0,0,0,0.2);
    width:${panelWidth}px;
    display:flex;
    flex-direction:column;
    gap:10px;
    overflow:hidden;
    cursor: default;
  `;
  panel.innerHTML = `
    <div style="display:flex;justify-content:space-between;align-items:center;">
      <button id="glossary-prev" style="background:rgba(255,255,255,0.15);border:none;color:#fff;font-size:18px;cursor:pointer;width:32px;height:32px;border-radius:50%;transition:all 0.2s;">←</button>
      <span id="glossary-counter" style="font-size:12px;opacity:0.8;font-weight:600;"></span>
      <button id="glossary-next" style="background:rgba(255,255,255,0.15);border:none;color:#fff;font-size:18px;cursor:pointer;width:32px;height:32px;border-radius:50%;transition:all 0.2s;">→</button>
    </div>
    <div id="glossary-body" style="margin-top:8px;max-height:250px;overflow-y:auto;line-height:1.5;"></div>
  `;
  container.appendChild(panel);

  const corner = document.createElement('div');
  corner.id = 'glossary-corner';
  corner.style.cssText = `
    position: absolute;
    left: -${cornerWidth}px;
    top: 50%;
    transform: translateY(-50%);
    width: ${cornerWidth}px;
    height: ${cornerWidth}px;
    background:${panelColor};
    border-radius:8px 0 0 8px;
    display:flex;
    align-items:center;
    justify-content:center;
    cursor:pointer;
    box-shadow:0 4px 12px rgba(0,0,0,0.3);
    z-index: 10;
    transition: transform 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    user-select: none;
  `;
  const logo = document.createElement('img');
  logo.src = 'https://' + window.location.hostname + '/cdn/shop/files/logo-min.png';
  logo.alt = 'Glossaire';
  logo.style.width = '25px';
  logo.style.height = '20px';
  corner.appendChild(logo);
  container.appendChild(corner);

  document.body.appendChild(container);

  // ===== Fonctions =====
  function renderDefinition() {
    const item = detectedTerms[currentIndex];
    document.getElementById('glossary-body').innerHTML = `
      <strong style="display:block;margin-bottom:8px;font-size:16px;color:#f5deb3;">${item.term}</strong>
      <span style="opacity:0.9;font-size:14px;">${item.definition}</span>
    `;
    document.getElementById('glossary-counter').textContent = `${currentIndex + 1} / ${detectedTerms.length}`;
  }

  function openPanel() {
    container.style.transform = 'translateX(0)';
    isOpen = true;
    corner.style.transform = 'translateY(-50%) scale(1.15)';
    setTimeout(() => { corner.style.transform = 'translateY(-50%) scale(1)'; }, 200);
  }

  function closePanel() {
    container.style.transform = `translateX(${panelWidth}px)`;
    isOpen = false;
    corner.style.transform = 'translateY(-50%)';
  }

  function navigate(direction) {
    currentIndex = (currentIndex + direction + detectedTerms.length) % detectedTerms.length;
    renderDefinition();
  }

  // ===== Événements =====
  corner.addEventListener('click', () => { isOpen ? closePanel() : openPanel(); });
  corner.addEventListener('mouseenter', () => {
    corner.style.transform = 'translateY(-50%) scale(1.15)';
    setTimeout(() => { if (!isOpen) corner.style.transform = 'translateY(-50%) scale(1)'; }, 200);
  });

  document.getElementById('glossary-prev').onclick = () => navigate(-1);
  document.getElementById('glossary-next').onclick = () => navigate(1);

  // clic/touch en dehors pour fermer
  document.addEventListener('click', e => { if (isOpen && !container.contains(e.target)) closePanel(); });
  document.addEventListener('touchstart', e => { if (isOpen && !container.contains(e.target)) closePanel(); });

  // fermeture au scroll
  window.addEventListener('scroll', () => { if (isOpen) closePanel(); });

  renderDefinition();

  // ===== Détecte et rend TOUS les mots cliquables (sauf dans filtres) =====
  detectedTerms.forEach((item, idx) => {
    const regex = new RegExp(`\\b(${item.term})\\b`, 'gi');
    const walker2 = document.createTreeWalker(contentArea, NodeFilter.SHOW_TEXT);
    const nodesToProcess = [];
    
    // Collecte tous les nœuds contenant le terme (en excluant les filtres)
    let node2;
    while (node2 = walker2.nextNode()) {
      const parent = node2.parentElement;
      
      // Exclut les filtres, listes déroulantes et le conteneur du glossaire
      if (parent.closest('#glossary-container, select, option, [role="listbox"], [role="option"], .facets, .filter, [data-filter], .dropdown, [aria-expanded]')) continue;
      
      if (regex.test(node2.textContent)) {
        nodesToProcess.push(node2);
      }
      regex.lastIndex = 0;
    }

    // Traite chaque nœud pour rendre TOUTES les occurrences cliquables
    nodesToProcess.forEach(node2 => {
      const text = node2.textContent;
      const matches = [];
      let match;
      const localRegex = new RegExp(`\\b(${item.term})\\b`, 'gi');
      
      while ((match = localRegex.exec(text)) !== null) {
        matches.push({ text: match[0], index: match.index });
      }

      if (matches.length > 0) {
        const frag = document.createDocumentFragment();
        let lastIndex = 0;

        matches.forEach(m => {
          // Texte avant le match
          if (m.index > lastIndex) {
            frag.appendChild(document.createTextNode(text.slice(lastIndex, m.index)));
          }

          // Terme cliquable
          const termSpan = document.createElement('span');
          termSpan.className = 'glossary-hover-term';
          termSpan.textContent = m.text;
          termSpan.style.cursor = 'pointer';
          
          // Événement clic
          termSpan.addEventListener('click', () => {
            currentIndex = idx;
            renderDefinition();
            requestAnimationFrame(() => {
              container.style.transform = 'translateX(0)';
              isOpen = true;
              corner.style.transform = 'translateY(-50%) scale(1.15)';
              setTimeout(() => { corner.style.transform = 'translateY(-50%) scale(1)'; }, 200);
            });
          });

          // Rebond au survol
          termSpan.addEventListener('mouseenter', () => {
            corner.style.transform = 'translateY(-50%) scale(1.15)';
            setTimeout(() => { if (!isOpen) corner.style.transform = 'translateY(-50%) scale(1)'; }, 200);
          });

          frag.appendChild(termSpan);
          lastIndex = m.index + m.text.length;
        });

        // Texte après le dernier match
        if (lastIndex < text.length) {
          frag.appendChild(document.createTextNode(text.slice(lastIndex)));
        }

        node2.parentNode.replaceChild(frag, node2);
      }
    });
  });
}
